import { Alert, Box, Button, ButtonGroup, Card, Grid, IconButton, Typography } from "@mui/material";
import { isMember } from "../helpers/user-helpers";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { selectLoggedInUser } from "../features/auth/auth.slice";
import NutritionPlanDayMemberView from "../features/nutrition/nutrition-plan/components/nutrition-plan-day-member-view";
import useActiveNutritionPlan from "../hooks/use-active-nutrition-plan";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import { BackIcon, ForwardIcon, RefreshIcon } from "../shared/icons";
import theme from "../app/app-theme";
import { useNavigate } from "react-router-dom";
import { fetchNutritionPlanForDay } from "../features/nutrition/nutrition-plan/nutrition-plan.slice";

const MemberNutrition = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const loggedInUser = useAppSelector(selectLoggedInUser);
    const memberId = loggedInUser?.roleData.member?.id;
    const activePlan = useActiveNutritionPlan(memberId ?? 0);

    const [day, setDay] = useState<string>(dayjs().format("YYYY-MM-DD"));

    useEffect(() => {
        dispatch(fetchNutritionPlanForDay({ day }));
    }, [dispatch, day]);

    return (
        <div>
            {isMember(loggedInUser) &&
                <>
                    {activePlan?.id ? (
                        <>
                            <Box display="flex" justifyContent="flex-end" sx={{ mb: 2 }}>
                                <Button variant="contained" color="primary" onClick={() => { navigate(`/members/${loggedInUser?.roleData.member?.id}/nutrition-plan`) }}>Edit Plan</Button>
                            </Box>
                            <Grid size={{ xs: 12, md: 6 }} justifyContent="center" alignItems="center" spacing={2} sx={{ display: 'flex', width: '100%', mb: 2 }}>
                                <Card sx={{ p: 2, justifyContent: 'center', alignItems: 'center', gap: 2, justifySelf: 'center', display: 'flex', flexDirection: 'column' }}>
                                    <Typography variant="body2">{`Plan Start Date: ${activePlan?.startDate ?? "N/A"} `}</Typography>
                                    <Typography variant="body2">{`Plan End Date: ${activePlan?.endDate ?? "N/A"} `}</Typography>
                                </Card>
                            </Grid>
                            <ButtonGroup variant="contained" aria-label="day navigation button group">
                                <IconButton onClick={() => setDay(dayjs(day).subtract(1, 'day').format("YYYY-MM-DD"))} sx={{ color: `${theme.palette.primary.main}`, ml: 1, mr: 1 }} disabled={day === activePlan?.startDate}><BackIcon /></IconButton>
                                <IconButton onClick={() => setDay(dayjs().format("YYYY-MM-DD"))} sx={{ color: `${theme.palette.primary.main}`, ml: 1, mr: 1 }}><RefreshIcon /></IconButton>
                                <Button disabled sx={{ width: '120px', ml: 1, mr: 1, color: `${theme.palette.primary.main}` }}>{day === dayjs().format("YYYY-MM-DD") ? "Today" : day}</Button>
                                <IconButton onClick={() => setDay(dayjs(day).add(1, 'day').format("YYYY-MM-DD"))} sx={{ color: `${theme.palette.primary.main}`, ml: 1, mr: 1 }}><ForwardIcon /></IconButton>
                            </ButtonGroup>
                            <div>
                                <NutritionPlanDayMemberView nutritionPlanId={activePlan?.id ?? 0} day={day} />
                            </div>
                        </>
                    ) : (
                        <>
                            <Alert severity="info" variant="filled" sx={{ width: 'fit-content', mb: 2, justifyContent: 'center' }}>
                                You do not have an active nutrition plan. Please create a new plan and add meals.
                            </Alert>

                            <Box display="flex" sx={{ mb: 2 }}>
                                <Button variant="contained" color="primary" onClick={() => { navigate(`/members/${loggedInUser?.roleData.member?.id}/nutrition-plan`) }}>Create Plan</Button>
                            </Box>
                        </>
                    )}

                </>
            }
        </div>
    )
}

export default MemberNutrition;